import React from "react";
import { HomeHero } from "@/components/home/HomeHero";
import { ServicesSection } from "@/components/home/ServicesSection";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { CommercialShowcase } from "@/components/home/CommercialShowcase";
import { ServiceArea } from "@/components/home/ServiceArea";
import { MissionCta } from "@/components/home/MissionCta";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-brand-bg text-slate-900">
      <HomeHero />
      <ServicesSection />
      <WhyChooseUs />
      <CommercialShowcase />
      <ServiceArea />
      <MissionCta />
    </div>
  );
}
